<template>
  <div class="saved-searches-wrapper">
    <div class="saved-searches" :class="isToggled ? 'opened' : 'closed'">
      <div class="title-wrapper">
        <h4>{{`Saved ${$route.name === 'analytics' ? 'Analytics' : $route.name === 'cics' ? 'CICS' : 'Searches'}`}}</h4>
      </div>
      <div class="searches-list w-100">
        <div v-for="(search, index) in savedSearches"
             class="saved-search d-flex flex-column justify-content-center align-items-center w-100"
             :key="`search-${index}`">
          <div class="d-flex align-items-center justify-content-between w-100">
            <h6 class="saved-search-title mb-0 ml-3">
              {{search.slug}}
            </h6>
            <div class="d-flex align-items-center mr-3">
              <h6 class="mb-0 mr-2">
                {{moment(new Date(search.created_at)).format('l')}}
              </h6>
              <button class="btn btn-block btn-outline-success mr-2" @click.stop="apply(search)"
                      style="width: 29px; height: 29px; margin-top: 0; padding: 0; border-radius: 1px;" type="button"><i
                  class="el-icon-circle-check"></i></button>
              <button class="btn btn-block btn-outline-danger" @click.stop="remove(search.id)"
                      style="width: 29px; height: 29px; margin-top: 0; padding: 0; border-radius: 1px;" type="button"><i
                  class="el-icon-delete"></i></button>
            </div>
          </div>
          <b-collapse :id="`collapse-${index}`" v-model="expandedSearches[index]" style="width: 100%">
            <div v-for="(field, fieldIndex) in parseData(search)" :key="`field-${fieldIndex}`">
              <template v-if="$route.name !== 'cics'">
                <div v-for="(data, dataIndex) in field" :key="`data-${dataIndex}`">
                  <div v-if="checkIfTagVisible(data)"
                       class="search-field d-flex align-items-center justify-content-between px-3 pt-2 mt-2"
                  >
                    <span class="mx-1" style="min-width: 100px">{{data.label}}:</span>
                    <template v-if="Array.isArray(data.value)">
                      <div class="d-flex align-items-center justify-content-end flex-wrap w-100 mt-n2">
                        <div v-for="(value, valueIndex) in data.value" :key="`tag-${value}-${valueIndex}`"
                                class="tag btn btn-outline-primary tag-value ml-2 mt-2" disabled>{{value}}
                        </div>
                      </div>
                    </template>
                    <template v-else-if="typeof data.value === 'object'">
                      <div class="d-flex align-items-center justify-content-end flex-wrap w-100">
                        <div class="tag btn btn-outline-primary tag-value ml-2" disabled>{{data.value.filter.from}} -
                          {{data.value.filter.to}}
                        </div>
                      </div>
                    </template>
                    <div v-else class="w-100 d-flex justify-content-end">
                      <div class="tag btn btn-outline-primary tag-value ml-2" disabled>{{data.value}}</div>
                    </div>
                  </div>
                  <div v-if="Array.isArray(data)"
                       class="search-field d-flex flex-column align-items-center justify-content-between px-3 pt-2 mt-2"
                  >
                    <span class="ml-1 mb-1" style="width: 100%">Metrics:</span>
                    <div v-for="(metric, idx) in data" class="my-1 w-100" :key="`saved-metric-${dataIndex}-${idx}`">
                      <div class="btn btn-outline-primary tag-value w-100" style="cursor: unset" disabled>
                        <div class="w-100 d-flex justify-content-between align-items-center">
                          <span>{{metric.metricType ? metric.metricType.value : '-'}}</span>
                          <span
                              style="text-transform: capitalize">{{metric.metric ? metric.metric.value : '-'}}</span>
                          <span
                              style="text-transform: capitalize">{{metric.aggregation ? metric.aggregation.value : '-'}}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <template v-else>
                <div v-if="checkIfCICSTagVisible(field)"
                     class="search-field d-flex align-items-center justify-content-between px-3 pt-2 mt-2">
                  <span class="mx-1" style="min-width: 100px">{{field.label}}:</span>
                  <template v-if="!['Geographical Type'].includes(field.label)">
                    <div class="w-100 d-flex justify-content-end">
                      <button class="tag btn btn-outline-primary tag-value ml-2" disabled>{{field.value}}</button>
                    </div>
                  </template>
                  <template v-else>
                    <div class="w-100 d-flex justify-content-end">
                      <button class="tag btn btn-outline-primary tag-value ml-2" disabled>{{filterValue(search)}}
                      </button>
                    </div>
                  </template>
                </div>
              </template>
            </div>
          </b-collapse>
          <div class="expand-search-button-wrapper" :class="{expanded: expandedSearches[index]}"
               @click="expandSearch(index)">
            <font-awesome-icon :icon="expandedSearches[index] ? 'angle-up' : 'angle-down'" color="#d1d4d7"
                               style="margin: 3px 0"></font-awesome-icon>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import studiesGetters from '../../store/modules/studies/getterTypes'
import searchFilters from '../../constants/searchFilters'

export default {
  name: 'SavedSearches',
  props: {
    apply: Function,
    remove: Function,
    yearsObject: Object
  },
  data () {
    return {
      isToggled: false,
      expandedSearches: {},
      blink: false
    }
  },
  computed: {
    ...mapGetters({
      savedSearches: studiesGetters.GET_SAVED_SEARCHES
    })
  },
  methods: {
    parseData (search) {
      // The chips render `label` per field, which the compact payload drops -
      // expand to put it back. A no-op for pre-existing saved searches.
      return searchFilters.expandSavedQuery(JSON.parse(search.metadata_query))
    },
    filterValue (search) {
      const data = JSON.parse(search.metadata_query)
      return data.geographicalValue ? data.geographicalValue.value : '-'
    },
    expandSearch (id) {
      this.expandedSearches[id] = !this.expandedSearches[id]
    },
    toggleBlink () {
      this.blink = true
      setTimeout(() => this.blink = false, 800)
    },
    checkIfTagVisible (tag) {
      if (!tag) return false
      if ((tag.value && !Array.isArray(tag.value)) || (Array.isArray(tag.value) && tag.value.length)) {
        if (['Start year', 'End year'].includes(tag.label)) {
          if (!this.yearsObject) return true
          return !(tag.label === 'Start year' && tag.value === this.yearsObject.min) && !(tag.label === 'End year' && tag.value === this.yearsObject.max)
        }
        return true
      }
      return false
    },
    checkIfCICSTagVisible (obj) {
      return obj.label !== 'Value'
    },
    toggle () {
      this.isToggled = !this.isToggled
    }
  }
}
</script>

<style scoped>
@keyframes blink {
  50% {
    background-color: #72bad8;
    color: white;
  }
}

.active {
  animation: blink 0.6s linear 1;
}

.saved-searches-wrapper {
  z-index: 1002;
  position: fixed;
  right: 0;
  bottom: 50px;
  height: calc(100% - 105px);
  display: flex;
  align-items: flex-end;
}

.title-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  border-bottom: 1px solid #d1d4d7;
  width: 100%;
  background-color: #f8f9fa;
}

.title-wrapper > h4 {
  margin: 0;
  white-space: nowrap;
  padding: 10px 12px;
}

.searches-list {
  overflow-y: scroll;
}

.saved-searches {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: white;
  border: 1px solid #d1d4d7;
  border-top: 0;
  border-bottom: 0;
  overflow: hidden;
  transition: 0.35s ease-in-out;
  margin-right: -2px;
}

.saved-search {
  padding-top: 7px;
  border-bottom: 1px solid #d1d4d7;
}

.saved-search-title {
  width: 160px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.expand-search-button-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.search-field {
  width: 100%;
  border-top: 1px dashed #d1d4d7;
}

.tag {
  width: unset !important;
  cursor: default;
}

.opened {
  width: 350px;
}

.closed {
  width: 0;
}

.expanded {
  margin-top: 10px;
}
</style>
